module.exports = [
	'Bidi_Class',
	'Bidi_Paired_Bracket_Type',
	'Binary_Property',
	'Block',
	'General_Category',
	'Script',
	'Script_Extensions'
];
